import uuid from 'helpers/uuid'

export const copyInvoiceItem = (item) => {
  return {
    ...item,
    id: uuid(),
    guid: uuid(),
    isNew: true,
  }
}

// New items are sent as id -1 until the server's id arrives, so a stable guid is what lets
// the server recognise a repeat save of the same item instead of inserting it again.
export const withInvoiceItemGuid = (item) => (item.guid ? item : {...item, guid: uuid()})
